import React from 'react'
import {
  List as UIList,
  ListItem,
  ListItemText,
  makeStyles,
  Typography,
} from '@material-ui/core'

import { useDispatch, useSelector } from 'react-redux'
import { distanceSelector, setDistance } from '../slices/locator'

const useStyles = makeStyles( {
  listContainer : {
    height : '100%',
    display : 'flex',
    flexDirection : 'column',
    backgroundColor : '#ffffff',
  },
  header : {
    padding : 4,
    borderBottom : '2px solid gray',
  },
  list : {
    maxHeight : '100%',
    overflow : 'hidden auto',
    flexGrow : 1,
  },
  label : {
    fontSize : 10,
  },
  noData : {
    display : 'flex',
    alignItems : 'center',
    justifyContent : 'center',
    height : '100%',
    fontSize : 18,
  },
  noDataText : {
    textAlign : 'center',
  },
} )

export default function List( props ) {
  const {
    sortedLocations,
    selected,
    onClick,
  } = props

  const distance = useSelector( distanceSelector )

  const classes = useStyles()

  return (
    <div
      className={classes.listContainer}
    >
      <div className={classes.list}>
        {sortedLocations.length > 0 ? (
          <UIList component="nav">
            {sortedLocations.map( ( location ) => (
              <ListItem
                key={location.id}
                selected={location === selected}
                button
                onClick={() => onClick( location )}
              >
                <ListItemText
                  primary={(
                    <Typography
                      variant="h6"
                      noWrap
                    >
                      {location.name}
                    </Typography>
)}
                  secondary={(
                    <>
                      <Typography variant="subtitle1">
                        {location.street}
                      </Typography>
                      <Typography variant="subtitle2">
                        {`${location.city}, ${location.state} ${location.zip}`}
                      </Typography>
                      <a
                        target="_blank"
                        href={`https://google.com/maps/search/${location.name.replace( /\s/g, '+' )}/@${location.latitude},${location.longitude}`}
                        rel="noreferrer"
                      >
                        Directions
                      </a>
                    </>
                  )}
                />
              </ListItem>
            ) )}
          </UIList>
        ) : (
          <div className={classes.noData}>
            <span className={classes.noDataText}>{`No locations within ${distance} miles of search`}</span>
          </div>
        )}
      </div>
    </div>
  )
}
